import React, { useContext } from 'react';

import SiteSeeContext from './SiteSeeContext';

import { ReactComponent as MobileMarkersIcon } from '../Map/MapControls/MapControlsMarkersToggle/MobileMarkersIcon.svg';
import { ReactComponent as MarkersIcon } from '../Map/MapControls/MapControlsMarkersToggle/MarkersIcon.svg';

const SiteSeeMarkersGuide = () => {
  const { isMobile, siteSeeName, actionWord } = useContext(SiteSeeContext);

  return (
    <>
      {`${actionWord} the`}

      <span className="siteSeeGuide__icon siteSeeGuide__icon--inline">
        { isMobile ? <MobileMarkersIcon /> : <MarkersIcon /> }
      </span>

      icon
      {' '}
      { isMobile ? `in the ${siteSeeName} control bar below ` : ''}
      to show/hide community amenity markers.
    </>
  );
};

export default SiteSeeMarkersGuide;
